export function isWorkEmail(email: string) {
  let forbiddenDomains = [
    'outlook.com',
    'outlook.co.uk',
    'yahoo.co.uk',
    'yahoo.com',
    'hotmail.com',
    'hotmail.co.uk',
    'sky.com',
    'icloud.com',
    'pm.me',
    'protonmail.com',
    'mac.com',
    'gmail.com',
  ]
  if (forbiddenDomains.some((v: string) => email.toLowerCase().includes(v))) {
    return false
  }
  return true
}